/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditScheduleAuditSchedulesBulkCreateMutationRequest, AuditScheduleAuditSchedulesBulkCreateMutationResponse, AuditScheduleAuditSchedulesBulkCreateQueryParams } from "../models/AuditScheduleAuditSchedulesBulkCreate";

export function getAuditScheduleAuditSchedulesBulkCreateUrl() {
  const res = { method: 'POST', url: `/audit-schedule/v1/schedules/bulk` as const }
  return res
}

/**
 * @description Creates multiple audit schedules in a single request.
 * @summary Create schedules (bulk)
 * {@link /audit-schedule/v1/schedules/bulk}
 */
export async function auditScheduleAuditSchedulesBulkCreate(data: AuditScheduleAuditSchedulesBulkCreateMutationRequest, params: AuditScheduleAuditSchedulesBulkCreateQueryParams, config: Partial<RequestConfig<AuditScheduleAuditSchedulesBulkCreateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditScheduleAuditSchedulesBulkCreateMutationResponse, ResponseErrorConfig<Error>, AuditScheduleAuditSchedulesBulkCreateMutationRequest>({ method : "POST", url : getAuditScheduleAuditSchedulesBulkCreateUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}